import type { PriceData } from "@/lib/pricing"

/**
 * Sentinel passed as `{price}` when a market has no authoritative base blood
 * price, so a catalog can drop its price clause with
 * `{price, select, none {…} other {… ab {price}}}` instead of rendering "ab ".
 *
 * Germany is the case today: its Vorsorge-Starter is not in the Stripe feed
 * yet (see `BASE_BLOOD_PRODUCT_IDS` in lib/pricing.ts), so the German city and
 * ad LPs show no price until it is, then pick it up with no code change.
 *
 * Kept out of lib/pricing.ts on purpose: many component tests mock that module
 * wholesale, and this helper must stay real under those mocks.
 */
export const NO_PRICE = "none"

/** `fullPrices.blood`, or {@link NO_PRICE} when the market has none. */
export function bloodPriceArg(data: PriceData | null | undefined): string {
  return data?.fullPrices.blood || NO_PRICE
}
